import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { movies } from "@/mocks/movies";

const hotNews = news.slice(1, 7);
const hotMovies = movies.filter((m) => m.hot).slice(0, 4);

export default function Sidebar() {
  return (
    <aside className="flex flex-col gap-6">
      <div className="bg-background-50 rounded-lg border border-background-200 p-5">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-fire-fill text-accent-500 text-lg" />
          <h3 className="font-heading font-bold text-base text-foreground-950">热点资讯榜</h3>
        </div>
        <ul className="flex flex-col">
          {hotNews.map((item, idx) => (
            <li key={item.id}>
              <Link
                to={`/detail/news/${item.id}`}
                className="group flex gap-3 py-3 border-b border-background-200 last:border-0 cursor-pointer"
              >
                <span
                  className={`w-5 shrink-0 font-heading font-extrabold text-sm ${
                    idx < 3 ? "text-accent-600" : "text-foreground-300"
                  }`}
                >
                  {idx + 1}
                </span>
                <span className="text-sm text-foreground-700 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-primary-700 rounded-lg p-5 text-background-50">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-star-smile-line text-accent-400 text-lg" />
          <h3 className="font-heading font-bold text-base">高分影片榜</h3>
        </div>
        <ul className="flex flex-col gap-3">
          {hotMovies.map((movie) => (
            <li key={movie.id}>
              <Link
                to={`/detail/movie/${movie.id}`}
                className="group flex items-center gap-3 cursor-pointer"
              >
                <div className="w-12 h-16 shrink-0 rounded-md overflow-hidden bg-secondary-800">
                  <img
                    src={movie.poster}
                    alt={`${movie.title} 封面`}
                    title={`${movie.title} 影片推荐 91电影`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-heading font-semibold text-sm truncate group-hover:text-accent-400 transition-colors">
                    {movie.title}
                  </p>
                  <p className="text-xs text-background-200/80 mt-1">{movie.year} · {movie.region}</p>
                </div>
                <span className="font-label font-bold text-accent-400 text-sm">
                  {movie.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to="/category/recommend"
          className="mt-5 flex items-center justify-center gap-1 w-full bg-accent-500 hover:bg-accent-600 text-secondary-950 text-sm font-bold rounded-md py-2.5 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览全部影片
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="bg-secondary-100 rounded-lg p-5 border border-background-200">
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-information-line text-primary-700 text-lg" />
          <h3 className="font-heading font-bold text-base text-foreground-950">关于91电影</h3>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed">
          专业的电影资讯与影片推荐平台，为你提供最新上映资讯、精选影片与深度影评，让每一次观影都更有依据。
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-1 text-primary-700 hover:text-primary-800 text-sm font-medium mt-3 whitespace-nowrap cursor-pointer"
        >
          了解更多
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
    </aside>
  );
}